import type { FriendlyCaptchaSDK } from '@friendlycaptcha/sdk';

import { isLocalEnv } from '../../helpers/feature-dev';

let instance: FriendlyCaptchaSDK | null = null;

export const generateFriendlyCaptchaInstance = async () => {
  if (instance === null) {
    const { FriendlyCaptchaSDK } = await import('@friendlycaptcha/sdk');
    instance = new FriendlyCaptchaSDK({
      // Optional, if you want to specify a custom endpoint.
      apiEndpoint: 'https://eu.frcapi.com/api/v2/captcha',
      // disableEvalPatching should be true if hot-reloading is used.
      disableEvalPatching: isLocalEnv,
    });
  }

  return Promise.resolve(instance);
};
